import {getElement} from "./helpers.js";
import {colorModal, sizeModal, protectionModalMobile, protectionModal, protectionModalEvents} from "./popups.js";
import smoothHeight from "./smoothHeight.js";

function openModal(el, target) {

    if (target.dataset.modal == 'color') {

        el.querySelector(".wrapper").innerHTML = colorModal(target.parentNode.closest('[data-product-id]'));
    }
    if (target.dataset.modal == 'size') {
        el.querySelector(".wrapper").innerHTML = sizeModal(target.parentNode.closest('[data-product-id]'));
    }
    if (target.dataset.modal == "protection level" || target.dataset.modal == "protection helmet") {

        if (matchMedia("(max-width: 767px)").matches) {
            el.querySelector(".wrapper").innerHTML = protectionModalMobile(target.dataset.modal, target.parentNode.closest('[data-product-id]'));
            smoothHeight(
                ".modal-protection__item",
                "[data-protect-smooth]",
                ".modal-protection__item-wrapper"
            );
        } else {
            el.querySelector(".wrapper").innerHTML = protectionModal(target.dataset.modal, target.parentNode.closest('[data-product-id]'));
        }
        protectionModalEvents();


    }

    if (!el.classList.contains('modal-overflow')) {
        adaptiveModalContent(el.querySelector(".modal__content"))
    }


    el.classList.add("show");
    el.classList.remove("hide");
    attachModalEvents(el);
}

function attachModalEvents(el) {
    if (el.querySelector('[data-close]')) {
        el
            .querySelectorAll('[data-close]').forEach(item => {
            item.addEventListener("click", () => {
                closeModal(el);
            });
        })

    }

    document.addEventListener("keydown", (e) => {
        handleEscape(e, el);
    });
    el.addEventListener("click", (e) => {
        handleOutside(e, el);
    });
}

function modalEvents(el) {
    el.classList.add("show");
    el.classList.remove("hide");
    document.body.classList.add("active");
    attachModalEvents(el);
}

function handleEscape(event, el) {
    if (event.key === "Escape") {
        closeModal(el);
    }
}

function handleOutside(event, el) {
    const isClickOutside = !!event.target.closest('[data-outside]');
    if (!isClickOutside) {

        // if (!el.classList.contains('modal-overflow')) {
            closeModal(el);
        // }
    }
}

function closeModal(el) {
    setTimeout(() => {
        el.classList.add("hide");
        el.classList.remove("show");
        if (getElement('.modal.show')) return;
        if (!el.classList.contains('modal-overflow')) {
            document.body.classList.remove("active");
        }return;

    }, 0);
    detachModalEvents(el);
    if (el.classList.contains('modal-overflow')) {
        setTimeout(() => {
            el.querySelector(".wrapper").innerHTML = ``;
        }, 250);
    }
}

function detachModalEvents(el) {
    if (el.querySelector('[data-close]')) {
        el
            .querySelectorAll('[data-close]').forEach(item => {
            item.removeEventListener("click", () => {
                closeModal(el);
            });
        })


    }
    document.removeEventListener("keydown", (e) => {
        handleEscape(e);
    });
    el.removeEventListener("click", (e) => {
        handleOutside(e);
    });
}

function adaptiveModalContent(el) {


    if (el) {
        const footer = document.querySelector(".modal__footer");
        let offset;
        if (matchMedia("(max-width: 767px)").matches) {
            offset = footer ? footer.clientHeight + 25 : 25;
            return (el.style.height = `calc(100vh - ${
                el.offsetTop + offset
            }px`);
        } else {
            offset = footer ? footer.clientHeight : 5;
            return (el.style.height = `calc(100vh - ${
                el.offsetTop + offset
            }px`);
        }


    }
}

export {modalEvents, adaptiveModalContent, openModal}
